import { media } from "./media";

export type Step = {
  readonly id: string;
  readonly index: string;
  readonly title: string;
  readonly body: string;
  readonly video: {
    readonly src: string;
    readonly poster: string;
    readonly width: number;
    readonly height: number;
  };
  readonly alt: string;
};

export const STEPS_LABEL = "How LOOP works";

export const CAROUSEL_FALLBACK_DWELL_MS = 5200;

export const STEPS: readonly Step[] = [
  {
    id: "import",
    index: "01",
    title: "Import",
    body: "Import an OBJ or .3dm file.",
    video: {
      src: media("Import.mp4"),
      poster: media("Apparel.png"),
      width: 1921,
      height: 1000,
    },
    alt: "Screen recording: importing a 3D file into LOOP",
  },
  {
    id: "design",
    index: "02",
    title: "Design",
    body: "Sketch directly onto your 3D model in your browser. Structure, yarn and colorway update in real time as you draw.",
    video: {
      src: media("Design.mp4"),
      poster: media("Sneaker.png"),
      width: 1920,
      height: 928,
    },
    alt: "Screen recording: sketching structure, yarn and colorway onto a 3D model in LOOP",
  },
  {
    id: "visualize",
    index: "03",
    title: "Visualize",
    body: "Use a digital twin to resolve more decisions before physical validation.",
    video: {
      src: media("Visualize.mp4"),
      poster: media("Accessories.png"),
      width: 1918,
      height: 926,
    },
    alt: "Screen recording: LOOP rendering a digital twin for design review before physical validation",
  },
  {
    id: "knit",
    index: "04",
    title: "Knit",
    body: "LOOP generates knit-ready machine data then production teams validate it through prototyping.",
    video: {
      src: media("Knit.mp4"),
      poster: media("Head.webp"),
      width: 1921,
      height: 1010,
    },
    alt: "Screen recording: exporting the finished knit from LOOP",
  },
];
